import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const packageService = {
    getAllPackages,
    getPackage,
    updatePackage,
    createPackage,
    updatePackageStatua,
};

const MODULE = {
    PACKAGE: 'packages',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllPackages(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company'] = sessionHelper.getStaffCompanyUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.PACKAGE}`, requestOptions)
}

export function getPackage(id) {
    return apiHelper(API_URL).get(`/${MODULE.PACKAGE}/${id}`)
}

export function updatePackage(data) {

    let services = data.services;

    // Intermediate object to track services by UUID
    let serviceMap = {};

    // Iterate over services and check for existing UUIDs
    services.forEach(service => {
        let uuid = service.uuid.uuid; // Assuming `uuid.value` holds the actual UUID
        let quantity = parseInt(service.quantity);

        // Check if the UUID already exists in the serviceMap
        if (serviceMap[uuid]) {
            // If exists, update the quantity by adding to the existing quantity
            serviceMap[uuid].quantity += quantity;
        } else {
            // If doesn't exist, add the service with its quantity
            serviceMap[uuid] = { uuid: uuid, quantity: quantity };
        }
    });

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'value', data.value);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    sharedHelper.appendIfNotNull(formData, 'after_service_description', data.afterServiceDescription);
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    Object.keys(serviceMap).forEach((uuid, index) => {
        formData.append(`services[${index}][uuid]`, uuid);
        formData.append(`services[${index}][quantity]`, serviceMap[uuid].quantity);
    });

    if (data.isRebookNeeded != "" && data.isRebookNeeded == true) {
        formData.append('is_rebook_needed', 1);
    }
    else {
        formData.append('is_rebook_needed', 0);
    }

    if (data.isStartTogether != "" && data.isStartTogether == true) {
        formData.append('is_start_together', 1);
    }
    else {
        formData.append('is_start_together', 0);
    }

    formData.append('_method', 'PUT');

    return apiHelper(API_URL).post(`/${MODULE.PACKAGE}/${data.id}`, formData)
}

export function createPackage(data) {
    const formData = new FormData();

    let services = data.services;

    // Intermediate object to track services by UUID
    let serviceMap = {};

    // Iterate over services and check for existing UUIDs
    services.forEach(service => {
        let uuid = service.uuid.value; // Assuming `uuid.value` holds the actual UUID
        let quantity = parseInt(service.quantity);

        // Check if the UUID already exists in the serviceMap
        if (serviceMap[uuid]) {
            // If exists, update the quantity by adding to the existing quantity
            serviceMap[uuid].quantity += quantity;
        } else {
            // If doesn't exist, add the service with its quantity
            serviceMap[uuid] = { uuid: uuid, quantity: quantity };
        }
    });


    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'value', data.value);
    sharedHelper.appendIfNotNull(formData, 'description', data.description);
    sharedHelper.appendIfNotNull(formData, 'after_service_description', data.afterServiceDescription);
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    Object.keys(serviceMap).forEach((uuid, index) => {
        formData.append(`services[${index}][uuid]`, uuid);
        formData.append(`services[${index}][quantity]`, serviceMap[uuid].quantity);
    });

    if (data.isRebookNeeded != "" && data.isRebookNeeded == true) {
        formData.append('is_rebook_needed', 1);
    }
    else {
        formData.append('is_rebook_needed', 0);
    }

    if (data.isStartTogether != "" && data.isStartTogether == true) {
        formData.append('is_start_together', 1);
    }
    else {
        formData.append('is_start_together', 0);
    }

    return apiHelper(API_URL).post(`/${MODULE.PACKAGE}`, formData)
}

export function updatePackageStatua(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.PACKAGE}/${data.id}`, requestOptions)
}